<template>
    <v-dialog persistent v-model="open" width="600">
        <template #activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" color="info" class="mx-1">
                <v-icon class="mr-1">mdi-account-edit</v-icon>
                Manage Users
            </v-btn>
        </template>
        <v-stepper v-model="step">
            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-card>
                        <v-card-title>Manage Users</v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :items="users">
                                <template #group.header="{ group }">
                                    <td class="text-start" colspan="2">
                                        {{ group }}
                                    </td>
                                </template>
                                <template #item.enabled="{ item }">
                                    <v-checkbox :input-value="item.enabled" @click="toggleUser(item)"></v-checkbox>
                                </template>
                                <template #item.button="{ item }">
                                    <v-btn @click="editUser(item)" color="warning">Edit</v-btn>
                                </template>
                            </v-data-table>
                            <div class="d-flex justify-center mt-4">
                                <v-btn @click="open = false" color="error">Close</v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="2">
                    <v-card-text>
                        <v-card-title>Assign User</v-card-title>
                        <v-card-text>
                            <v-row no-gutters align="center">
                                <v-col>
                                    <v-text-field disabled label="Email" v-model="editEmail"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="center">
                                <v-col>
                                    <v-select label="Org" v-model="editOrg" :items="orgs" item-value="uuid" item-text="name"></v-select>
                                </v-col>
                            </v-row>
                            <v-row no-gutters align="center">
                                <v-col>
                                    <v-select label="Type" v-model="editType" :items="typeItems" item-value="value" item-title="text"></v-select>
                                </v-col>
                            </v-row>
                            <v-snackbar v-model="statusAlert" timeout="2500" color="success">{{ statusMessage }}</v-snackbar>
                        </v-card-text>
                        <v-card-actions class="justify-space-between">
                            <v-btn @click="step = 1" color="error">Back</v-btn>
                            <v-btn @click="submitEdit" color="success">Save</v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
            </v-dialog>
</template>

<script>
import * as api from '@/api'

export default {
    name: 'ManageUsers',
    props: {
        apiBase: String,
        token: String,
        users: Array,
        orgs: Array,
    },
    data: () => ({
        open: false,
        headers: [
            { text: 'Email', value: 'email' },
            { text: 'Enabled', value: 'enabled', sortable: true, filterable: true, groupable: true },
            { text: '', value: 'button' },
        ],
        loading: [],
        user: null,
        step: 1,
        statusAlert: false,
        statusMessage: "",
        editType: null,
        editOrg: null,
        editEmail: null,
        typeItems: [
            { text: "Customer", value: "" },
            { text: "Access Employee", value: "e" },
            { text: "Access Manager", value: "m" },
        ],
    }),
    watch: {
        editOrg: function(newVal) {
            console.log(newVal)
        }
    },
    methods: {
        async del(item) {
            if (this.loading.includes(item.part)) {
                return
            }
            this.loading.push(item.part)
            const r = await api.deletePart(this.apiBase, { id: this.token }, item)
            if (r.errorMessage != null) {
                this.$emit('error', r)
            } else {
                this.$emit('del', item)
            }
            // Wait until next tick to remove the loading indicator so the app
            // can remove the part first, preventing the icon from reverting to
            // delete before the row is removed.
            this.$nextTick(() => {
                // This is async. Don't assume the part removed is still at the
                // end of the loading list.
                this.loading = this.loading.filter((p) => p !== item.part)
            })
        },
        isDeleting(item) {
            return this.loading.includes(item.part)
        },
        partLink(object) {
            const url = new URL(`/part/${object}`, this.apiBase)
            return url.toString()
        },
        toggleUser(user) {
            if (user.enabled) {
                api.disableUser(this.apiBase, { id: this.token }, user.username)
                user.enabled = false
            } else {
                api.enableUser(this.apiBase, { id: this.token }, user.username)
                user.enabled = true
            }
        },
        editUser(user) {
            this.step = 2
            this.user = user
            this.editEmail = user.email
            let userOrg = this.orgs.find(org => org.uuid == user.org)
            this.editOrg = userOrg?.uuid
            console.log("org list", this.orgs)
            console.log(this.editOrg)
            let userType = this.typeItems.find(tp => tp.value == user.type)
            console.log(userType)
            this.editType = userType
        },
        submitEdit() {
            if (this.user.email != this.editEmail || this.user.type != this.editType) {
                api.editUser(this.apiBase, { id: this.token }, this.user.username, this.editEmail, this.editType)
            }

            // detect if the user org changed
            let userOrg = this.orgs.find(org => org.uuid == this.user.org)
            if (userOrg != null) {
                if (userOrg.uuid != this.editOrg) {
                    api.assignUser(this.apiBase, { id: this.token }, { username: this.user.username, org_uuid: this.editOrg})
                }
            } else if (this.editOrg != null) {
                api.assignUser(this.apiBase, { id: this.token }, { username: this.user.username, org_uuid: this.editOrg})
            }
            this.$emit('refresh')
            this.statusAlert = true
            this.statusMessage = "Successfully updated user"
        }
    },
}
</script>
